import { EDIT_GLOBAL_SEGMENTS, SUPER_USER } from 'shared/constants/permissions';
import CustomResult from './CustomResults/CustomResult';
import Funnels from './Funnels';
import Segments from './Segments/Segments';

const routes = [{
  path: 'funnels',
  component: Funnels,
  label: 'Funnels',
},
{
  path: 'custom-result',
  component: CustomResult,
  label: 'Custom result',
  permission: SUPER_USER,
}, {
  path: 'segments',
  component: Segments,
  label: 'Segments',
  permission: EDIT_GLOBAL_SEGMENTS,
}];

export default routes;
